/**
 * Copies of `INTENTS` and `KNOWN_BRAND_SLUGS` from @sophie/determinism, which
 * the web BUNDLE cannot import at runtime (the package's dist is CJS and
 * Rollup cannot see named exports through its star re-exports — every other
 * web import from it is type-only). Vitest resolves the package fine, so
 * `filing.test.ts` pins these copies against the real vocabularies and drift
 * fails CI instead of shipping a stale dropdown. The server validates every
 * write against the real lists regardless, so drift could never mean a bad
 * write — only a missing option.
 */

/**
 * The RUNNER's six, not the router's twenty. The first version listed every
 * routing intent, and a reviewer refiled two cases to `request_return` and
 * `cancel_order` — perfectly real production intents the eval runner has no
 * workflow for — which silently validated those cases out of the next run.
 * Mirrors `CASE_INTENTS` in @sophie/eval; `filing.test.ts` pins the mirror.
 */
export const INTENT_OPTIONS: readonly string[] = [
  'refund_request',
  'cancel_subscription',
  'cancel_vitality_club',
  'tracking',
  'chargeback_dispute',
  'other',
];

export const BRAND_OPTIONS: readonly string[] = [
  'american-vitality',
  'daily-elixirs',
  'everfaith',
  'golden-harmony',
  'lifegauge',
  'metaera',
  'nation-health-md',
  'nature-s-blast',
  'petmade',
  'pureance',
  'purehealth-research',
  'sanolabs',
  'trumeta',
  'vivasabia',
];
